export default __webpack_public_path__ + "aef00332a15ceeb2b4ff62ddb3e1dd13.png";